// Imports:

// Styles:
import 'bootstrap/scss/bootstrap.scss';

// Main.scss should always be last, otherwise your styles can be overwrite by styles from libraries
import '../scss/main.scss';


// Common libraries: 
import $ from 'jquery';
window.jQuery = $;
window.$ = $;


// Popper - neccessary for bootstrap
import Popper from 'popper.js/dist/umd/popper.js';
window.Popper = Popper;

import 'bootstrap';

// Plugins
import './plugins/Load-DependenciesPlugin.js';
import './plugins/Lazy-LoadPlugin.js';

// Components:
// 

// Script to handle menuPages
// Handle show/hide of menu with all pages

// Get menu element
let BwMenuPages = $("[data-item='BW-navigation-menu']");

// Check if menu exists
if (BwMenuPages.length > 0) {

    // Show/hide on button with menu icon
    $("[data-item='BW-navigation-button']").on("click", () => {
        if (BwMenuPages.length > 0) {
            // Check if menu is visible
            if (BwMenuPages.hasClass("visible") !== true) {
                // If true -> animate show
                BwMenuPages.addClass("visible");
                BwMenuPages.animate({ "opacity": "1" }, 300);
            }
            else {
                // If false -> animate hide
                BwMenuPages.animate({ "opacity": "0" }, 300, function () {
                    BwMenuPages.removeClass("visible");
                });
            }
        }
    });

    // Hide on button 'X" click
    $("[data-action='BW-navigation-hide']").on("click", () => {
        if (BwMenuPages.length > 0) {
            // Animate hide
            BwMenuPages.animate({ "opacity": "0" }, 300, function () {
                BwMenuPages.removeClass("visible");
            });
        }
    });
}

// Remove preload class on load
window.addEventListener('load', () => {
    setTimeout(function () {

        // Trigger click on data-trigger on load elements
        $("[data-trigger='on-load']").each(function () {
            $(this).trigger("click");
        });

        // hide loader
        let loader = $("[data-item='loader']");
        loader.animate({ "opacity": 0 }, 300, () => {
            loader.addClass("hidden");
            setTimeout(() => {
                ifSectionActive();
            }, 450);

            // Add scroll handler for active sections
            window.addEventListener('scroll', () => {
                ifSectionActive();
            })
        });

        // Get body
        document.getElementsByTagName("body")[0].classList.remove("preload");
        // $("[data-item='loader-styles']").remove();
    }, 100);
})

// Set section to 'active' if visible
function ifSectionActive() {
    // CHECK POSITION OF SCROLL AND SET SECTIONS ABOVE TO ACTIVE

    let scrollTop;

    if ($(document).width() > 992) {
        scrollTop = $(document).scrollTop() + (2 * $(window).height() / 3);
    }
    else {
        scrollTop = $(document).scrollTop() + ($(window).height() - 150);
    }

    $("[data-item='section']").each(function () {
        let position = $(this).offset().top;
        let element = $(this);
        // Check scrollTop for section visibility
        if (scrollTop + 200 >= position) {
            // Check if element is already visible
            if(!element.attr("data-visible") === true || !element.attr("data-visible") === "true") {
                // If not add class that is visible
                element.addClass('visible');
                element.attr("data-visible", "true");
    
                // If its section hero, add listener to handle iteration of animation
                if(element.attr("data-section") === "hero") {
                    if(element.length > 0) {
                        // If there is section image add listener to animation end
                        // sectionImage[0];
                        let animationsCounter = 0;
                        element[0].addEventListener("animationend", () => {
                            animationsCounter++;

                            if(animationsCounter === 11) {
                                // If all animations finished, restart animation
                                element.removeClass("visible");
                                setTimeout(() => {
                                    element.addClass("visible");

                                    // And reset counter
                                    animationsCounter = 0;
                                }, 50);
                            } 
                        })
                    }
                }
            }
        }
    });
}
